import { baseAPI } from '~shared/api/base-api';

interface ReportingGroupEnrollmentsParams {
  format?: string;
  sessionId: string;
  groupId: string;
  classId?: string;
}

export const reportingGroupEnrollmentsAPI = async (
  params: ReportingGroupEnrollmentsParams,
) => {
  const response = await baseAPI.get<string>('reporting/group-enrollments', {
    params,
    responseType: 'text',
  });
  return response.data;
};
